import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition } from "vue"
import _imports_0 from '../../assets/images/TAYKUS.svg'
import _imports_1 from '../../assets/images/arrow-prev.svg'
import _imports_2 from '../../assets/images/border-button1.svg'
import _imports_3 from '../../assets/images/border-button.svg'
import _imports_4 from '../../assets/images/border-3.svg'
import _imports_5 from '../../assets/images/border-button4.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute w-full",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = { class: "flex justify-between relative h-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "slide-position flex h-16" }
const _hoisted_6 = { class: "w-120" }
const _hoisted_7 = {
  key: 0,
  class: "next-button absolute w-full cursor-pointer"
}
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "button-next-img absolute",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "next-button absolute w-full cursor-pointer"
}
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "button-next-img absolute",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_13 = {
  key: 2,
  class: "next-button absolute w-full cursor-pointer"
}
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "button-next-img absolute",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_16 = {
  key: 3,
  class: "next-button absolute w-full cursor-pointer"
}
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "button-next-img absolute",
  src: _imports_1,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsuallyGame = _resolveComponent("UsuallyGame")!
  const _component_UsuallyPlay = _resolveComponent("UsuallyPlay")!
  const _component_PlayDay = _resolveComponent("PlayDay")!
  const _component_UsuallyDo = _resolveComponent("UsuallyDo")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.$store.state.onboardingIsOpen)
        ? (_openBlock(), _createBlock(_component_Popup, {
            key: 0,
            class: "reference-onboarding",
            showOkButton: false,
            onPopupMounted: _ctx.handlePopupMounted
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("header", _hoisted_2, [
                (_ctx.selectedValue > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveIndicator(-1))),
                      class: "cursor-pointer back-button h-8 w-8 flex justify-center items-center"
                    }, _hoisted_4))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "cursor-pointer ml-auto",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeOnboarding()))
                }, _toDisplayString(_ctx.$t("skip")), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (indicator, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass([
              'indicator h-1 w-full',
              { 'select-indicator': index  === _ctx.selectedValue },
              { 'select-indicator': index + 1  === _ctx.selectedValue },
              { 'select-indicator': index + 2 === _ctx.selectedValue },
              { 'select-indicator': index + 3  === _ctx.selectedValue },
            ])
                    }, null, 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.selectedValue == 0)
                  ? (_openBlock(), _createBlock(_component_UsuallyGame, { key: 0 }))
                  : _createCommentVNode("", true),
                (_ctx.selectedValue == 1)
                  ? (_openBlock(), _createBlock(_component_UsuallyPlay, {
                      key: 1,
                      onShowNextStep: _ctx.moveIndicator
                    }, null, 8, ["onShowNextStep"]))
                  : _createCommentVNode("", true),
                (_ctx.selectedValue == 2)
                  ? (_openBlock(), _createBlock(_component_PlayDay, { key: 2 }))
                  : _createCommentVNode("", true),
                (_ctx.selectedValue == 3)
                  ? (_openBlock(), _createBlock(_component_UsuallyDo, { key: 3 }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.selectedValue == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("img", {
                        class: "button-next-b absolute",
                        src: _imports_2,
                        alt: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveIndicator(1)))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedValue == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("img", {
                        class: "button-next-b absolute",
                        src: _imports_3,
                        alt: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveIndicator(1)))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedValue == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("img", {
                        class: "button-next-b absolute",
                        src: _imports_4,
                        alt: "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moveIndicator(1)))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedValue == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("img", {
                        class: "button-next-b absolute",
                        src: _imports_5,
                        alt: "",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.moveIndicator(1)))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onPopupMounted"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}